export const FEATURE_NAME = '@zerops/zerops/core/promo-code-base';
